import { AGGREGATOR_TYPE } from "../data/outlet-status-constants";
import * as ICONS from "../assets/icons";
import { EMAIL_IDS_ALLOWED_FOR_RECON_ENGINE, FULFILLMENT_STATUS_TYPES } from "../data/accounting-constants";
import { getLocalStorage } from "../utils";
import { DEVICE_IDENTIFIER } from "../data/local-storage-constants";
import { cloneDeep } from "lodash";
import { SORT_VALUE_TYPES, SALES_AUDIT_OPTIONS_MAP } from "../data/constants";
import store from "../redux/store";
import { currency } from "./common-helper";
import moment from "moment";

/**
 * This function will transform input aggregationData into list of records
 * @param aggregationData
 */
export function transformReconAggregationData(aggregationData: any = {}) {
  return {
    orderType: aggregationData.ORDER_TYPE,
    data: [
      {
        key: "totalRecords",
        rista: aggregationData.TOTALRECORDS,
        aggregator: aggregationData.TOTALRECORDS,
        label: "No. of Orders",
      },
      {
        key: "itemTotal",
        label: "Item Total",
        rista: aggregationData.ITEMTOTALRISTA,
        aggregator: aggregationData.ITEMTOTALAGGREGATOR,
      },
      {
        key: "charges",
        label: "Packaging & Service charges",
        rista: aggregationData.CHARGESRISTA,
        aggregator: aggregationData.CHARGESAGGREGATOR,
      },
      {
        key: "discount",
        label: "Discount",
        rista: aggregationData.DISCOUNTRISTA,
        aggregator: aggregationData.DISCOUNTAGGREGATOR,
      },
      {
        key: "netBillValue",
        label: "Net Bill Amount",
        rista: aggregationData.NETBILLVALUERISTA,
        aggregator: aggregationData.NETBILLVALUEAGGREGATOR,
      },
      {
        key: "aggregatorPlatformFee",
        label: "Aggregator Platform Service Fee",
        rista: aggregationData.AGGREGATORPLATFORMFEERISTA,
        aggregator: aggregationData.AGGREGATORPLATFORMFEEAGGREGATOR,
      },
      {
        key: "finalPayout",
        label: "Total Customer Payable",
        rista: aggregationData.FINALPAYOUTRISTA,
        aggregator: aggregationData.FINALPAYOUTAGGREGATOR,
      },
    ],
  };
}

export function getAggregatorLogo(aggregatorType: string) {
  switch (aggregatorType) {
    case AGGREGATOR_TYPE.swiggy.id:
      return ICONS.ic_swiggy_logo;
    case AGGREGATOR_TYPE.zomato.id:
    default:
      return ICONS.ic_zomato_logo;
  }
}

export function getFulfillmentStatusTextColor(status: string) {
  switch (status) {
    case FULFILLMENT_STATUS_TYPES.Accepted:
      return "#2A77F2";
    case FULFILLMENT_STATUS_TYPES.Created:
      return "#575757";
    case FULFILLMENT_STATUS_TYPES.Delivered:
      return "#4E875B";
    case FULFILLMENT_STATUS_TYPES.Dispatched:
      return "#6283AC";
    case FULFILLMENT_STATUS_TYPES.Processed:
      return "#E7B73D";
    default:
      return "";
  }
}

export function haveReconEngineAccess () {
  const deviceIdentifier = getLocalStorage(DEVICE_IDENTIFIER) || "";
  return EMAIL_IDS_ALLOWED_FOR_RECON_ENGINE.indexOf(deviceIdentifier) !== -1;
}

//get sum of all the values in a map on the basis of key
export function getCumulativeSum(targetMap: any, value: any) {
  let cumulativeSum = targetMap?.reduce((a: any, b: any) => {
    return Math.trunc(a * 100 + b[value] * 100) / 100;
  }, 0);
  return cumulativeSum;
}

function compareVals(a: any, b: any, type: string) {
  switch (type) {
    case SORT_VALUE_TYPES.number:
      return a - b;
    case SORT_VALUE_TYPES.string:
      return a.localeCompare(b);
    default:
      return true;
  }
}
export function sortListByKey(listToSort: any, getKey: any, type: string) {
  let dataSort = cloneDeep(listToSort);
  dataSort.sort(function (a: any, b: any) {
    return compareVals(getKey(a), getKey(b), type);
  });
  return dataSort;
}

export function getAuditLogHeaderDetails(selectedId: string, auditData: any) {
  const currencySymbol:any = currency();

  let result: any = [];

  switch (selectedId) {
    case SALES_AUDIT_OPTIONS_MAP.payment.id:
      result = auditData.map((audit: any) => currencySymbol + audit.paymentTotal);
      break;
    case SALES_AUDIT_OPTIONS_MAP.balancedue.id:
      result = auditData.map((audit: any) => currencySymbol + audit.balanceAmount);
      break;
    case SALES_AUDIT_OPTIONS_MAP.discount.id:
      result = auditData.map((audit: any) => currencySymbol + -audit.netDiscountTotal);
      break;
    case SALES_AUDIT_OPTIONS_MAP.cancelledtickets.id:
      result = auditData.map((audit: any) => audit.cancelledTicketCount);
      break;
    case SALES_AUDIT_OPTIONS_MAP.modifiedtickets.id:
      result = auditData.map((audit: any) => audit.modifiedTicketCount);
      break;
    case SALES_AUDIT_OPTIONS_MAP.reprints.id:
      result = auditData.map((audit: any) => audit.reprintCount || 0);
      break;
    default:
      break;
  }

  return result;
}


export function getBillHtml(saleData: any) {
  let staticUrl = process.env.REACT_APP_RISTA_ITEM_BASE_URL!
  // to add only the base url to saledata
  const saleDataCloned = {
    ...saleData,
    staticURL : staticUrl.slice(0, -1)
  };
  let businessData = store.getState().businessReducer.businessData,
    windowObj: any = window;
  const saleWithBillTemplateConfig = {};
  Object.assign(saleWithBillTemplateConfig, cloneDeep(saleDataCloned), {
    showPhoneNumber: businessData.billTemplate.showPhoneNumber,
  });
  let result = windowObj.RL.bill.getDIV(saleWithBillTemplateConfig, {
    billTemplate: businessData.billTemplate,
  });
  return result;
}
export const canModifyCardBalance = (row: any) => {
    if (!row?.expiryDate) return true;
    const now = moment();
    const expiryMoment = moment(row.expiryDate, "YYYY-MM-DD HH:mm");
    return expiryMoment.isBefore(now);
  };

export const isCardActive= (row: any) => {
    if (!row?.expiryDate) return false;
    const now = moment();
    const expiryMoment = moment(row.expiryDate, "YYYY-MM-DD HH:mm");
    return expiryMoment.isBefore(now);
  };